import React, { useCallback, useContext } from 'react';
import { mapLocaleToMeaningfulFormat } from '@/helpers/utils/i18n';
import { ProductContext } from './../../contexts';
import StarFill from '../../../../../../customercenter-ui/components/icons/startFill';
import { getAttribute } from '../../../../../../customercenter-ui/components/product/details/helpers/utils/productDataUtils';

const ProductNameSection = () => {
  const { initialColor, isCompleteOutOfStock } = useContext(ProductContext);
  const { initialSize, isMailOrderProduct } = useContext(ProductContext);
  const getAttributeValue = useCallback(getAttribute, [initialSize]);
  const abwStyle = getAttributeValue('abwStyle', initialSize);

  const getDisplayName = () => {
    const colorName = initialColor?.name;
    const hasInventory = initialColor?.activeFilters?.hasInvenotry ?? false;
    if (!colorName) return '';
    if (hasInventory || !isCompleteOutOfStock) {
      return colorName;
    } else {
      return `${colorName} - ${mapLocaleToMeaningfulFormat().outOfStock}`;
    }
  };
  return (
    <section className="py-6">
      <h1 className="text-[22px] font-bold leading-7" dangerouslySetInnerHTML={{ __html: getDisplayName() || '' }} />
      {!isMailOrderProduct && (
        <section className="flex items-center pt-2">
          <p className="border-r border-[#656668] pr-3 text-sm font-normal leading-5">
            {mapLocaleToMeaningfulFormat().item} #: {abwStyle}
          </p>
          {typeof window !== 'undefined' && window.pwrData?.average_rating ? (
            <section className="flex gap-x-0.5 pl-2.5">
              <StarFill value={window.pwrData?.average_rating} count={5} productId={initialColor?.key} />
              <p className="pl-2.5 text-sm font-normal leading-5">({window.pwrData?.review_count} Reviews)</p>
            </section>
          ) : (
            <section className="flex gap-x-0.5 pl-2.5">
              <p className="font-normal">No Review</p>
            </section>
          )}
        </section>
      )}
      {isMailOrderProduct && <p className="mt-3">Item #: 999999</p>}
    </section>
  );
};

export default ProductNameSection;
